import { Dashboard } from '../pages/home/types';
import { useApi } from './use-api-call';
import { useApiResult } from './use-api-result';

export const useDashboardInitApi = (muted: boolean) =>
    useApi<Dashboard.DashboardDTO>('/dashboard/init-dashboard', { muted });

export const useDashboardInitApiResult = () =>
    useApiResult<Dashboard.DashboardDTO>('/dashboard/init-dashboard');
